module.exports = __webpack_public_path__ + "img/03.d8091f92.jpg";